import cookie from 'cookie'
import store from 'store2'
import fetch from 'fetch'
import event from 'event'
import Geolocation from 'Geolocation'
import Progress from 'progress'
import {
  query
} from 'qs'
import { cities } from './citiesData'
var progress = new Progress()

// 如果url有城市参数，可以根据url参数指定城市
// 如果url没有城市参数，读取cookie中城市
// 如果url, cookie中都没有城市参数，发送ip路由的api请求

class CityManager {
  constructor () {
    this.cities = cities
    this.currentCity = this.getCurrentCity()
  }
  init (clearCity) {
    return new Promise((resolve, reject) => {
      if (clearCity || query.clearCity) {
        this.clearCity()
      }
      // 如果syncCityCookie，则以localStorage为准，会无视cookie中传的
      // 造成如果在其他平台切了cookie，在m站下又会切回来。
      // this.syncCityCookie()
      return this.getCities()
        .then((cities) => {
          this.cities = cities
          return this.getCurrentCityAsync()
        })
        .then((currentCity) => {
          this.setCurrentCity(currentCity)
          return currentCity
        })
        .then(resolve)
        .catch(reject)
    })
  }
  setCities (cities) {
    this.cities = cities
  }
  clearCity () {
    store.remove('curCity')
    cookie.remove('cityId', '.piaoniu.com', '/')
  }
  syncCityCookie () {
    let storeCity = store.get('curCity')
    let city = storeCity ? storeCity.data : null
    if (city) {
      this.clearCity()
      cookie.set('cityId', city.cityId, 24 * 365, '.piaoniu.com', '/')
    }
  }
  getCurrentCityAsync () {
    return new Promise((resolve, reject) => {
      var cityEnName = query.city || ''
      var city
      if (!cityEnName) {
        // url没有城市，先从cookie获取
        let cityId = this.getCurrentCity().cityId
        if(process.server){
          cityId = cookie.get('cityId')
        }
        // let cityId = cookie.get('cityId')
        if (cityId) {
          cityId = +cityId
        }
        if (!cityId) {
          // 如果cookie没有，首先根据GPS获取城市
          // 如果用户浏览器不支持GPS，那么根据ip获取城市
          Geolocation.getLocation()
            .then((location) => {
              return this.getCityByGPS(location)
            }, () => {
              return this.getCityByIp()
            })
            .then((city) => {
              this.setCurrentCity(city)
              resolve(city)
            }, (err) => {
              progress.showMessage(err)
            })
        } else {
          // 如果cookie中有则无需再设置城市
          city = this.getCityByCityId(cityId, this.cities)
          resolve(city)
        }
      }
       else {
        // url有指定城市直接设置城市
        city = this.getCityByEnName(cityEnName, this.cities)
        if (this.getCurrentCity().cityId != city.cityId) {
          this.setCurrentCity(city)
        }
        resolve(city)
      }
    })
  }
  getHotCities () {
    return fetch({
      url: '/v1/cities/hot',
      session: true,
      key: 'hotCities',
      noRepeat: true
    })
  }
  getActiveCities () {
    return fetch({
      url: '/v1/cities/active',
      session: true,
      key: 'activeCities',
      noRepeat: true
    })
  }
  getV2ActiveCities () {
    return fetch({
      url: '/v2/cities/active',
      session: true,
      key: 'v2ActiveCities',
      noRepeat: true
    })
  }
  getCities () {
    if (this.getCityReq) {
      return this.getCityReq
    }
    this.getCityReq = new Promise((resolve, reject) => {
      if (this.cities && this.cities.length) {
        return resolve(this.cities)
      }
      fetch({
        url: '/v1/cities/',
        session: true,
        key: 'cities',
        noRepeat: true
      })
      .then((cities) => {
        this.cities = cities
        resolve(cities)
        return cities
      })
      .catch(reject)
    })
    return this.getCityReq
  }
  getCityByGPS (location) {
    return fetch({
      url: `/v1/cities/currentByGeo?latitude=${location.latitude}&longitude=${location.longitude}`,
      noRepeat: true
    })
  }
  getCityByIp () {
    return fetch({
      url: '/v1/cities/current', // 用户第一次用，根据ip自动路由
      noRepeat: true
    })
  }
  setCurrentCity (city) {
    let storeCity = store.get('curCity')
    if (!storeCity || !storeCity.data || city.cityId !== this.currentCity.cityId) {
      this.clearCity()      
      this.currentCity = city
      cookie.set('cityId', city.cityId, 24 * 365, '.piaoniu.com', '/')
      store.set('curCity', { data: city })
      this.emit('change', city)
    }
  }
  getCurrentFromCookie () {
    return cookie.get('cityId') ? +cookie.get('cityId') : 1
  }
  getCurrentCity () {
    let storeCity = store.get('curCity')
    console.log(storeCity,typeof storeCity,'获取到的城市信息')
    let city = (storeCity && storeCity.data) ? storeCity.data : {
      cityEnName: 'shanghai',
      cityName: '上海',
      cityId: 1
    }
    return city
    //sessionStorage.getItem('currentCity') ||
    // return store.get('currentCity') || JSON.parse( '{"cityEnName":"shanghai","cityName":"上海","cityId":1}') || {
    //   cityEnName: 'shanghai',
    //   cityName: '上海',
    //   cityId: 1
    // }
  }
  getWithCache (key, keyVal, cities) {
    let cacheKey = key + 'Cache'
    if (!this[cacheKey]) {
      this[cacheKey] = {}
    }
    if (this[cacheKey][keyVal]) {
      return this[cacheKey][keyVal]
    }
    cities = cities || this.cities
    let val = cities.filter((item) => {
      return item[key] === keyVal
    })[0]
    if (val) {
      this[cacheKey][keyVal] = val
    }
    return val
  }
  getCityByAbbrCode (abbrCode, cities) {
    return this.getWithCache('cityAbbrCode', abbrCode, cities)
  }
  getCityByEnName (cityEnName, cities) {
    return this.getWithCache('cityEnName', cityEnName, cities)
  }
  getCityByCityId (cityId, cities) {
    return this.getWithCache('cityId', cityId, cities)
  }
  getCityByCityIdAsync (cityId) {
    return new Promise((resolve, reject) => {
      this.getCities().then((cities) => {
        var city = this.getCityByCityId(cityId, cities)
        resolve(city)
      })
    })
  }
  getCityByEnNameAsync (cityEnName) {
    return new Promise((resolve, reject) => {
      this.getCities().then((cities) => {
        var city = this.getCityByEnName(cityEnName, cities)
        resolve(city)
      })
    })
  }
}

event.mixin(CityManager)
CityManager.shared = new CityManager()

export default CityManager



// WEBPACK FOOTER //
// ./src/mods/cityManager.js